<nb-card class="form">
  <nb-card-header>
    <h4>
      {{
        (featureSet
          ? "pages.organisation.featureSets.edit"
          : "pages.organisation.featureSets.create"
        ) | translate
      }}
    </h4>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <label class="label">
        {{ "pages.organisation.featureSets.nameLabel" | translate }}
      </label>
      <input
        nbInput
        fullWidth
        [(ngModel)]="name"
        placeholder="{{ 'pages.organisation.featureSets.namePlaceholder' | translate }}"
      />
    </div>

    <div class="form-group">
      <label class="label">
        {{ "pages.organisation.featureSets.permissionsLabel" | translate }}
      </label>
      <div class="permissions-grid">
        <label
          class="permission-item"
          *ngFor="let perm of availablePermissions"
          [nbTooltip]="
            'enums.featureSetPermissions.' + perm + '.tooltip' | translate
          "
        >
          <nb-checkbox
            [checked]="hasPermission(perm)"
            (checkedChange)="togglePermission(perm)"
          >
            {{ "enums.featureSetPermissions." + perm + ".label" | translate }}
          </nb-checkbox>
        </label>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" (click)="cancel()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      (click)="save()"
      [disabled]="!name.trim() || saving"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
